'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memberStatus = require('enums/memberStatus');

var _availabilityReasons = require('constants/availability-reasons');

var _Schedules = require('derivers/Schedules');

var _Schedules2 = _interopRequireDefault(_Schedules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScheduleAction = function getScheduleAction(memberStatus, schedule) {
  var _ScheduleDeriver$avai = _Schedules2.default.availabilityData(schedule),
      availableToPurchase = _ScheduleDeriver$avai.availableToPurchase,
      availableToReserve = _ScheduleDeriver$avai.availableToReserve,
      reasonCode = _ScheduleDeriver$avai.reasonCode;

  switch (memberStatus) {
    case (0, _memberStatus.memberStatus)('UNPAID'):
    case (0, _memberStatus.memberStatus)('ACTIVE'):
      if (reasonCode === _availabilityReasons.RESERVED) {
        return 'cancel';
      }

      if (!availableToReserve && availableToPurchase) {
        return 'buy';
      }

      if (!availableToReserve && reasonCode === _availabilityReasons.PLAN_DOES_NOT_ALLOW_RESERVATIONS) {
        return 'signup';
      }

      return availableToReserve ? 'reserve' : 'disable';
    case (0, _memberStatus.memberStatus)('CANCELLED'):
      return 'reactivate';
    case (0, _memberStatus.memberStatus)('UNSUBSCRIBED'):
    default:
      return 'join';
  }
};

exports.default = getScheduleAction;